(function () {
  'use strict';

  angular.module('app').component('confirmXmlPage', ConfirmXmlPageComponent());

  function ConfirmXmlPageComponent() {
    return {
      bindings: {},
      controller: ConfirmXmlDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/confirm-xmls/confirm-xml-page.component.html',
    };
  }

  ConfirmXmlDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'ConfirmXmlService',
  ];

  function ConfirmXmlDetailCtrl($location, $routeParams, AbilityService, ConfirmXmlService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_confirmxml_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onConfirmXmlSaved = onConfirmXmlSaved;
    vm.onConfirmXmlCanceled = onConfirmXmlCanceled;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        vm.loadingItem = true;
        ConfirmXmlService.getConfirmXml(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onConfirmXmlSaved(item) {
      $location.path(`/confirm_xmls/${item.id}`);
    }

    function onConfirmXmlCanceled() {
      $location.path('/confirm_xmls');
    }
  }
})();
